// extracted by mini-css-extract-plugin
export default {"approval-title":"t2Dp1N6hhQQqyRgXvuEk","approval-type":"yRpBHX9hipE3RmywtXj0"};